import { isProduction } from '@fourthwall/utils/dist/dev'
import type { ReactNode } from 'react'
import React from 'react'
import * as S from './InProgress.styled'

type Props = {
  inline?: boolean
  disabled?: boolean
  children: ReactNode
}

export const InProgress = ({ inline, disabled, children }: Props) => {
  if (isProduction() && !disabled) {
    return null
  }

  return (
    <S.Container $inline={inline}>
      {children}
      <S.Note>in progress</S.Note>
    </S.Container>
  )
}
